import VariableValueCell from "./VariableValueCell";

export default VariableValueCell;
